import { supabase } from '../supabaseClient'

function pickMelhorOs(lista) {
  if (!lista?.length) return null
  const rank = (status) => {
    if (status === 'Validado' || status === 'Finalizado') return 5
    if (status === 'Em andamento') return 4
    if (status === 'Novo') return 3
    if (status === 'Cancelado') return 1
    return 2
  }
  return [...lista].sort((a, b) => {
    const d = rank(b.status) - rank(a.status)
    if (d) return d
    return String(b.created_at || '').localeCompare(String(a.created_at || ''))
  })[0]
}

function vistoriaFeita(status) {
  const s = String(status || '').toLowerCase()
  return ['aprovado', 'aprovado com obra', 'concluida', 'finalizado', 'validado', 'revisado'].includes(s)
}

function estadoVistoria(os, form) {
  const status = form?.status || os?.status
  if (!os && !form) return { estado: 'nao_iniciado', detalhe: 'Não iniciada' }
  if (vistoriaFeita(status)) return { estado: 'concluido', detalhe: 'Realizada' }
  const s = String(status || '')
  if (s === 'Reprovado' || s === 'Reprovada') return { estado: 'reprovado', detalhe: 'Reprovada' }
  if (s === 'Cancelado' || s === 'Cancelada') return { estado: 'cancelado', detalhe: 'Cancelada' }
  if (s === 'Em andamento') return { estado: 'andamento', detalhe: 'Em andamento' }
  return { estado: 'inicio', detalhe: s || 'Pendente' }
}

function estadoInstalacao(os) {
  if (!os) return { estado: 'nao_iniciado', detalhe: 'Não iniciada' }
  const status = os.status || 'Novo'
  if (status === 'Finalizado' || status === 'Validado') return { estado: 'concluido', detalhe: 'Concluída' }
  if (status === 'Em andamento') return { estado: 'andamento', detalhe: 'Em andamento' }
  if (status === 'Cancelado') return { estado: 'cancelado', detalhe: 'Cancelada' }
  return { estado: 'inicio', detalhe: 'Aguardando início' }
}

function etapaPorTipo(etapas, tipo) {
  return (etapas || []).find((e) => e.tipo_etapa === tipo) || null
}

function etapaIniciada(etapa) {
  if (!etapa) return false
  return etapa.status === 'aprovado' || !!(etapa.protocolo && String(etapa.protocolo).trim()) || !!etapa.data_etapa
}

function estadoHomologacao(fluxo, cliente) {
  const homologado = fluxo?.homologado === true || cliente?.homologado === true
  if (homologado) {
    return { estado: 'concluido', detalhe: 'Homologado' }
  }
  if (!fluxo) return { estado: 'nao_iniciado', detalhe: 'Não iniciada' }
  const parecer = etapaPorTipo(fluxo.etapas, 'parecer')
  const vistoria = etapaPorTipo(fluxo.etapas, 'vistoria')
  const carga = etapaPorTipo(fluxo.etapas, 'aumento_carga')
  if (parecer?.status === 'aprovado' && vistoria?.status === 'aprovado' && carga?.status === 'aprovado') {
    return { estado: 'andamento', detalhe: 'Aguardando homologação' }
  }
  if (etapaIniciada(carga) && carga?.status !== 'aprovado') {
    return { estado: 'andamento', detalhe: 'Aumento de Carga' }
  }
  if (etapaIniciada(vistoria) && vistoria?.status !== 'aprovado') {
    return { estado: 'andamento', detalhe: 'Vistoria de conexão' }
  }
  if (parecer?.status === 'aprovado') {
    return { estado: 'andamento', detalhe: 'Parecer de Acesso emitido' }
  }
  if (etapaIniciada(parecer)) {
    return { estado: 'andamento', detalhe: 'Parecer de Acesso' }
  }
  return { estado: 'nao_iniciado', detalhe: 'Não iniciada' }
}

function etapaCadastro() {
  return { id: 'cadastro', label: 'Cadastro', detalhe: 'Aguardando início', classe: 'badge-etapa-cadastro' }
}

export function montarEtapaProcessoCliente({ cliente, osInstalacao, osVistoria, formVistoria, fluxo }) {
  const vist = estadoVistoria(osVistoria, formVistoria)
  const inst = estadoInstalacao(osInstalacao)
  const hom = estadoHomologacao(fluxo, cliente)

  if (hom.estado === 'concluido') {
    return { id: 'homologado', label: 'Homologado', detalhe: hom.detalhe, classe: 'badge-etapa-homologado' }
  }
  if (hom.estado !== 'nao_iniciado') {
    return { id: 'homologacao', label: 'Homologação', detalhe: hom.detalhe, classe: 'badge-etapa-homologacao' }
  }
  if (inst.estado === 'andamento' || inst.estado === 'inicio') {
    return { id: 'instalacao', label: 'Instalação', detalhe: inst.detalhe, classe: 'badge-etapa-instalacao' }
  }
  if (vist.estado === 'andamento' || vist.estado === 'inicio' || vist.estado === 'reprovado') {
    return { id: 'vistoria', label: 'Vistoria', detalhe: vist.detalhe, classe: 'badge-etapa-vistoria' }
  }
  if (inst.estado === 'concluido') {
    return { id: 'homologacao', label: 'Homologação', detalhe: 'Aguardando início', classe: 'badge-etapa-homologacao' }
  }
  if (vist.estado === 'concluido') {
    return { id: 'instalacao', label: 'Instalação', detalhe: 'Aguardando início', classe: 'badge-etapa-instalacao' }
  }
  return etapaCadastro()
}

async function buscarEmLotes(tabela, coluna, ids, select) {
  const resultado = []
  for (let i = 0; i < ids.length; i += 80) {
    const lote = ids.slice(i, i + 80)
    const { data, error } = await supabase.from(tabela).select(select).in(coluna, lote)
    if (error) throw error
    resultado.push(...(data || []))
  }
  return resultado
}

export async function enriquecerClientesComEtapa(clientesList) {
  const lista = clientesList || []
  if (!lista.length) return lista

  const ids = lista.map((c) => c.id).filter(Boolean)
  try {
    const { data: tipos, error: errTipos } = await supabase.from('tipo_servico').select('id, nome')
    if (errTipos) throw errTipos

    const idVistoria = (tipos || []).find((t) => String(t.nome || '').trim().toLowerCase() === 'vistoria')?.id || null

    const [ordens, formsVistoria, fluxos] = await Promise.all([
      buscarEmLotes(
        'ordens_servicos',
        'id_cliente',
        ids,
        'id, id_cliente, id_tipo_servico, status, created_at'
      ),
      buscarEmLotes(
        'vistorias',
        'id_cliente',
        ids,
        'id, id_cliente, status, data_vistoria, created_at'
      ),
      buscarEmLotes(
        'fluxo_cliente',
        'cliente_id',
        ids,
        'id, cliente_id, homologado, data_homologado, created_at, etapas:fluxo_cliente_etapas(*)'
      )
    ])

    const osPorCliente = new Map()
    for (const os of ordens || []) {
      if (!os.id_cliente) continue
      const atual = osPorCliente.get(os.id_cliente) || { vistoria: [], instalacao: [] }
      if (idVistoria && String(os.id_tipo_servico) === String(idVistoria)) {
        atual.vistoria.push(os)
      } else {
        atual.instalacao.push(os)
      }
      osPorCliente.set(os.id_cliente, atual)
    }

    const formPorCliente = new Map()
    for (const form of formsVistoria || []) {
      if (!form.id_cliente) continue
      const atual = formPorCliente.get(form.id_cliente)
      if (!atual || String(form.created_at || '') > String(atual.created_at || '')) {
        formPorCliente.set(form.id_cliente, form)
      }
    }

    const fluxoPorCliente = new Map()
    for (const fluxo of fluxos || []) {
      if (!fluxo.cliente_id) continue
      const atual = fluxoPorCliente.get(fluxo.cliente_id)
      if (!atual || String(fluxo.created_at || '') > String(atual.created_at || '')) {
        fluxoPorCliente.set(fluxo.cliente_id, fluxo)
      }
    }

    return lista.map((cliente) => {
      const os = osPorCliente.get(cliente.id) || { vistoria: [], instalacao: [] }
      return {
        ...cliente,
        etapa_processo: montarEtapaProcessoCliente({
          cliente,
          osInstalacao: pickMelhorOs(os.instalacao),
          osVistoria: pickMelhorOs(os.vistoria),
          formVistoria: formPorCliente.get(cliente.id) || null,
          fluxo: fluxoPorCliente.get(cliente.id) || null
        })
      }
    })
  } catch (err) {
    console.warn('Não foi possível carregar a etapa dos clientes:', err?.message || err)
    return lista.map((cliente) => ({
      ...cliente,
      etapa_processo: cliente.homologado === true
        ? { id: 'homologado', label: 'Homologado', detalhe: 'Homologado', classe: 'badge-etapa-homologado' }
        : etapaCadastro()
    }))
  }
}
